export enum SystemConfigurationName {
    ShowCategories = 'ShowCategories',
    EnableInteractionThresholdAlert = 'EnableInteractionThresholdAlert',
    EnableAccountNumber = 'EnableAccountNumber',
    EnableDateOfBirth = 'EnableDateOfBirth',
    EnableCustomField = 'EnableCustomField',
    EnablePhoneNumber = 'EnablePhoneNumber',
    EnableEmailAddress = 'EnableEmailAddress',
    EnableRemoteCheckIn = 'EnableRemoteCheckIn',
    PassFileExport = 'PassFileExport',
    DefaultLobbyTab = 'DefaultLobbyTab',
    DefaultAlertSound = 'DefaultAlertSound',
    StaffStatusDisplayText = 'StaffStatusDisplayText',
    EnablePartialClose = 'EnablePartialClose',
    CommentsRequired = 'CommentsRequired',
    EnableReferenceNumber = 'EnableReferenceNumber',
    MakeStaffMemberSelectionMandatory = 'MakeStaffMemberSelectionMandatory',
    AccountNumberDisplayText = 'AccountNumberDisplayText',
    AccountNumberDisplayTextLanguage = 'AccountNumberDisplayTextLanguage',
    AccountNumberMaskingOption = 'AccountNumberMaskingOption',
    CustomFieldText = 'CustomFieldText',
    CustomFieldTextLanguage = 'CustomFieldTextLanguage',
    DefaultCentralView = 'DefaultCentralView',
    InteractionThreshold = 'InteractionThreshold',
    EnableAlertPopups = 'EnableAlertPopups',
    AllowRemoteCheckInBeforeAppointmentTime = 'AllowRemoteCheckInBeforeAppointmentTime',
    EnableUserImpersonation = 'EnableUserImpersonation',
    PassFileLocationText = 'PassFileLocationText',
    ExportTime = 'ExportTime',
    MonthlyExportDate = 'MonthlyExportDate',
    EnableWaitSmarter = "EnableWaitSmarter",
    AutomaticCheckInForWaitSmarter = "AutomaticCheckInForWaitSmarter",
    WaitTimeThresholdInWaitSmarterLowerBound = "WaitTimeThresholdInWaitSmarterLowerBound",
    WaitTimeThresholdInWaitSmarterUpperBound = "WaitTimeThresholdInWaitSmarterUpperBound",
    EnableTextMessageNotification = "EnableTextMessageNotification",
    EmailFromDisplayName = "EmailFromDisplayName",
    EnableTextMessageLanguagePreference = "EnableTextMessageLanguagePreference",
    DefaultLocationAddressForGeoLocation = "DefaultLocationAddressForGeoLocation",
    TimeOutDuration = "TimeOutDuration",
    ClientAdminEmail = "ClientAdminEmail",
    EmailSenderAddress = "EmailSenderAddress",
    EmailFromAddress = "EmailFromAddress",
    EmailReplyAddress = "EmailReplyAddress",
    JitPermissionGroup = "JitPermissionGroup",
    JitHomeLocation = "JitHomeLocation",
    JitEnableUseAppointment = "JitEnableUseAppointment",
    AppointmentStatusSetAtTheEndOfTheDay = "AppointmentStatusSetAtTheEndOfTheDay",
    ChangeAppointmentStatusAutomaticallyAtTheEndOfTheDay = "ChangeAppointmentStatusAutomaticallyAtTheEndOfTheDay",
    AllowWidgetAppointmentThrough = "AllowWidgetAppointmentThrough",
    ConfirmationEmailSentFromAssignedEmployee = "ConfirmationEmailSentFromAssignedEmployee",
    FloatTravelPadTime = "FloatTravelPadTime",
    GliaEnabled = "GliaEnabled",
    GliaSiteId = "GliaSiteId"
}
